import React from 'react';
import { Bets } from '@alien-platform/bo-core';

import { Row } from '@/types/general';
import { HorizontalTable } from '@/components/core/horizontal-table';

export function StatusResponseTable({ betData }: { betData: Bets }): React.JSX.Element {
  const statusResponseData: Row[] = [
    {
      label: {
        text: 'Approved By',
      },
      value: {
        text: ``,
      },
    },
    {
      label: {
        text: 'PL',
      },
      value: {
        text: betData.pl || 0,
      },
    },
    {
      label: {
        text: 'Before Balance',
      },
      value: {
        text: ``,
      },
    },
    {
      label: {
        text: 'After Balance',
      },
      value: {
        text: ``,
      },
    },
  ];

  return <HorizontalTable header="Status Response" tableData={statusResponseData} />;
}
